var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_vm._v("\n\t\t"+_vm._s(_vm.currency.symbol)+"\n\t")]),_vm._v(" "),_c('input',{staticClass:"form-control input-sm",attrs:{"type":"text","name":_vm.name},domProps:{"value":_vm.amount},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }